import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, ArrowLeft, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { adminLogin, isAuthed } from "@/lib/admin-api";
import SimbaLogo from "@/components/SimbaLogo";

export default function AdminLoginPage() {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthed()) navigate("/admin", { replace: true });
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setBusy(true);
    try {
      await adminLogin(password);
      toast.success("Welcome back.");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center -mt-24 pt-24" data-testid="admin-login-page">
      <div className="w-full max-w-md p-10 bg-sand border border-ink/10">
        <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-muted2 hover:text-terracotta mb-8">
          <ArrowLeft className="w-3 h-3" /> Back to site
        </Link>
        <SimbaLogo className="h-10 w-auto mb-6" />
        <div className="flex items-center gap-3 mb-2">
          <Lock className="w-5 h-5 stroke-1 text-terracotta" />
          <div className="overline text-terracotta">Simba Travel CMS</div>
        </div>
        <h1 className="editorial-h2 mb-2">Admin sign in.</h1>
        <p className="text-sm text-muted2 mb-10">Restricted area. Authorised Simba Travel staff only.</p>

        <form onSubmit={submit}>
          <label className="label-line">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-password-input"
            className="input-line"
            autoComplete="current-password"
            required
          />
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="btn-primary w-full mt-10 disabled:opacity-60"
          >
            {busy ? <><Loader2 className="w-4 h-4 animate-spin" /> Signing in</> : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
